<template>
<div v-if ="signInfo"  class="tab-wrapper">
  <h3>基本信息</h3>
  <div class="content">
    <p>
      <span class="label">公司名称：</span>
      <span class="info">{{signInfo.signName}}</span>
    </p>
    <p>
      <span class="label">公司地址：</span>
      <span class="info">{{signInfo.businessAddress}}</span>
    </p>
    <div>
      <span class="label">企业资质：</span>

      <div class="license-wrap">
        <span class="info">{{`${signInfo.businessQualificationName}号 ${signInfo.businessQualification || ''}`}}</span>
        <div class="license" v-for="(item,i) in signInfo.businessLicenseList"><img class="file-img" :src="item.attachmentImgUrl" @click.stop="showImg(item.attachmentImgUrl)" alt="营业执照"></div>
      </div>
    </div>
    <p>
      <span class="label">代理人：</span>
      <span class="info">{{signInfo.contactsName}}</span>
    </p>

    <p>
      <span class="label">签约手机号：</span>
      <span class="info">{{signInfo.userPhone}}</span>
    </p>
    <p>
      <span class="label">代理人证件号：</span>
      <span class="info">{{signInfo.contactsIdcard}}</span>
    </p>
    <p>
      <span class="label">代理人邮箱：</span>
      <span class="info">{{signInfo.contactsMail}}</span>
    </p>

    <div>
      <span class="label">委托证明：</span>
      <div class="img-wrap" v-for="(item,i) in signInfo.grantAuthList"><img class="file-img" :src="item.attachmentImgUrl" @click.stop="showImg(item.attachmentImgUrl)" alt="委托证明"></div>
    </div>
  </div>

</div>

</template>

<script type="text/ecmascript-6">

export default {
  props:{
    signInfo: {
      type:Object,
      default:null
    }
  },
 data () {
 return {

 };
 },
  methods:{
    showImg(src) {
      this.$emit('showimg', src)
    }
  }
}
</script>
<style scoped>
h3{
  margin-bottom: 16px;
}
h4 {
  margin-bottom: 8px;
}
.label {
  display: inline-block;
  text-align: right;
  width: 90px;
  line-height: 2.5;
}
.info {
  padding-left: 20px;
  font-weight: 600;
}

p {
  line-height: 2.5;
}
.img-wrap {
  display: inline-block;
  vertical-align: text-top;
  padding-left:20px;
}
 .file-img {
    width: 150px;
    height: 100px;
    overflow: hidden;
    display: inline-block;
    /*margin-bottom: 20px;*/
  }
  .license-wrap {
    display: inline-block;
    vertical-align: text-top;
  }
  .license {
    padding-left: 20px;
    padding-top: 8px;
  }
</style>

